var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{opacity:0.2;fill:#231F20;}\n\t.st1{fill:#FFFDFE;stroke:#FFFDFE;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n"),React.createElement("circle",{"className":"st0","cx":"34.5","cy":"34","r":"30.3","key":1}),React.createElement("polygon",{"className":"st1","points":"32.8,27.1 39.9,34 32.8,40.9 ","key":2})]);
}

IconPlay.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 69 69","style":{"enableBackground":"new 0 0 69 69"},"xmlSpace":"preserve"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
